"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferRibbon = exports.OldOfferPrice = exports.Offer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function Offer({ product, t, isMobile }) {
    const text = t(isMobile
        ? i18n_1.Strings.userOnboarding.subsSheet.buy.offer
        : i18n_1.Strings.userOnboarding.subsSheet.buy.student.discount);
    return ((0, jsx_runtime_1.jsxs)(OfferContainer, { isMobile: isMobile, "data-e2e": 'Offer_OfferContainer', children: [(0, jsx_runtime_1.jsx)(exports.OldOfferPrice, { isMobile: isMobile, "data-e2e": 'Offer_OldOfferPrice', children: product.price.formattedValue }), (0, jsx_runtime_1.jsx)(exports.OfferRibbon, { isMobile: isMobile, color: "#EFF0F1", height: 20, "data-e2e": 'Offer_OfferRibbon', children: text })] }));
}
exports.Offer = Offer;
const OfferContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding-top: 1em;

  ${({ isMobile }) => isMobile && `padding-top: 0em;`}
`;
exports.OldOfferPrice = styled_components_1.default.div `
  color: #4b4f55;

  font-size: 32px;
  text-decoration: line-through;
  align-self: center;

  ${({ isMobile }) => isMobile &&
    `
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 0.5em;
  `}
`;
exports.OfferRibbon = (0, styled_components_1.default)(ui_1.Pennon) `
  color: #4b4f55;

  text-transform: uppercase;
  align-self: center;
  text-align: center;

  font-size: 11px;
  padding: 0 0 0 15px;
  margin-top: 0.5em;

  ${({ isMobile }) => isMobile &&
    `
      max-width: 98px;
      font-size: 8px;
      padding: 0 0 0 5px;
      margin-top: 0em;
  `}
`;
